(function () {
  if (window.__freeShippingBarBound === true) return;
  window.__freeShippingBarBound = true;

  var formatMoneyMXN = function (cents) {
    var amount = Math.max(0, Math.round(cents)) / 100;
    try {
      return amount.toLocaleString('es-MX', { style: 'currency', currency: 'MXN', maximumFractionDigits: 0 });
    } catch (error) {
      return '$' + Math.round(amount);
    }
  };

  var renderShippingBar = function (cartTotalCents) {
    var $bar = document.querySelector('[data-free-shipping]');
    if ($bar == null) return;
    var threshold = parseInt($bar.getAttribute('data-threshold'), 10);
    if (isNaN(threshold) || threshold <= 0) return;
    if (isNaN(cartTotalCents)) cartTotalCents = 0;

    // QA 26.07.26: si se paso hide-above (ver snippets/free-shipping-bar.liquid),
    // la barra se oculta por completo una vez que el carrito llega a ese
    // monto -- arriba de ese punto la tarifa real de Shopify vuelve a
    // cobrar envio, asi que seguir diciendo "ya tienes envio gratis"
    // seria confuso. Se re-evalua en cada refresco (sube y baja) para
    // que reaparezca si el cliente quita productos y vuelve a bajar del
    // monto.
    var hideAbove = parseInt($bar.getAttribute('data-hide-above'), 10);
    if (!isNaN(hideAbove) && hideAbove > 0) {
      $bar.hidden = cartTotalCents >= hideAbove;
    }

    var remaining = threshold - cartTotalCents;
    var $text = $bar.querySelector('[data-free-shipping-text]');
    if ($text != null) {
      var newHtml = remaining > 0
        ? 'Te faltan <strong>' + formatMoneyMXN(remaining) + '</strong> para el <strong>Env\u00edo Express Gratis</strong>'
        : '\u00a1Tu pedido ya tiene <strong>Env\u00edo Express Gratis</strong>!';
      if ($text.innerHTML !== newHtml) $text.innerHTML = newHtml;
    }

    var $fill = $bar.querySelector('[data-free-shipping-fill]');
    if ($fill != null) {
      var pct = Math.max(0, Math.min(100, (cartTotalCents / threshold) * 100));
      $fill.style.width = pct + '%';
    }
  };

  var refreshFromCart = function () {
    var $bar = document.querySelector('[data-free-shipping]');
    if ($bar == null) return;
    window.fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (cart != null && typeof cart.total_price === 'number') {
          $bar.setAttribute('data-cart-total', cart.total_price);
          renderShippingBar(cart.total_price);
        }
      })
      .catch(function () {});
  };

  var delayedRefresh = function () {
    window.setTimeout(refreshFromCart, 350);
  };

  /* PDP: eventos oficiales de Rebuy Smart Cart */
  ['rebuy:cart.change', 'rebuy:cart.add', 'rebuy:cart.ready', 'rebuy:cart.item-removed', 'rebuy:cart.item-increase', 'rebuy:cart.item-decrease'].forEach(function (eventName) {
    document.addEventListener(eventName, delayedRefresh);
  });

  /* Cualquier request AJAX al carrito (add/change/update/clear) via fetch, ej. PDP */
  if (window.__fsCartFetchPatched !== true) {
    window.__fsCartFetchPatched = true;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var isCartRequest = false;
      try {
        var url = arguments[0];
        var urlString = typeof url === 'string' ? url : (url != null && url.url != null ? url.url : '');
        isCartRequest = urlString.indexOf('/cart/add') !== -1
          || urlString.indexOf('/cart/change') !== -1
          || urlString.indexOf('/cart/update') !== -1
          || urlString.indexOf('/cart/clear') !== -1;
      } catch (error) {}
      var result = originalFetch.apply(this, arguments);
      if (isCartRequest) result.then(delayedRefresh).catch(function () {});
      return result;
    };
  }

  /* Pagina /cart: el theme actualiza cantidades via jQuery $.post, no via
     fetch, asi que tambien escuchamos directamente esos triggers. */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target != null && target.classList != null && target.classList.contains('js-cart-item-input')) {
      delayedRefresh();
    }
  });
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target == null || target.closest == null) return;
    if (target.closest('[data-action="plus"], [data-action="minus"], .quantity-selector-button, .product-form__submit') != null) {
      delayedRefresh();
    }
  });

  /* Volver con back/forward cache (ej. desde el carrito hacia la PDP) */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted === true) refreshFromCart();
  });
})();
